// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const XCloseIcon = /* @__PURE__ */ createIcon(
  'x-close',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M17.293 5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 1 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 1 1 1.414-1.414L12 10.586z',
      },
    ],
  ]
);
